<template>
    <v-form
        data-vv-scope="newPersonEmergencyContactForm"
    >
        <v-layout wrap>
            <v-flex
                md8
                sm8
                xs12
            >
                <v-text-field
                    :error-messages="newPersonEmergencyContactNameErrors"
                    @blur="$v.newPersonEmergencyContactName.$touch()"
                    @input="$v.newPersonEmergencyContactName.$touch()"

                    label="Name"
                    type="text"
                    v-model="newPersonEmergencyContactName"
                />
            </v-flex>
            <v-flex
                md4
                sm4
                xs12
            >
                <v-select
                    :error-messages="newPersonEmergencyContactRelationshipErrors"
                    :items="relationshipTypeList"
                    @blur="$v.newPersonEmergencyContactRelationship.$touch()"
                    @input="$v.newPersonEmergencyContactRelationship.$touch()"

                    label="Relationship"
                    type="text"
                    v-model="newPersonEmergencyContactRelationship"
                />
            </v-flex>
            <v-flex
                md4
                sm6
                xs12
            >
                <v-text-field

                    :error-messages="newPersonEmergencyContactTelephoneErrors"
                    @blur="$v.newPersonEmergencyContactTelephone.$touch()"
                    @input="$v.newPersonEmergencyContactTelephone.$touch()"

                    label="Telephone"
                    type="text"
                    v-model="newPersonEmergencyContactTelephone"
                />
            </v-flex>
            <v-flex
                md4
                sm6
                xs12
            >
                <v-text-field
                    :error-messages="newPersonEmergencyContactMobilePhoneErrors"
                    @blur="$v.newPersonEmergencyContactMobilePhone.$touch()"
                    @input="$v.newPersonEmergencyContactMobilePhone.$touch()"

                    label="Mobile"
                    type="text"
                    v-model="newPersonEmergencyContactMobilePhone"
                />
            </v-flex>
            <v-flex
                md4
                sm6
                xs12
            >
                <v-text-field
                    :error-messages="newPersonEmergencyContactEmailAddressErrors"
                    @blur="$v.newPersonEmergencyContactEmailAddress.$touch()"
                    @input="$v.newPersonEmergencyContactEmailAddress.$touch()"


                    label="Email"
                    type="text"
                    v-model="newPersonEmergencyContactEmailAddress"
                />
            </v-flex>
            <v-flex
                md12
                sm6
                xs12
            >
                <v-text-field
                    :error-messages="newPersonEmergencyContactAddressLineOneErrors"
                    @blur="$v.newPersonEmergencyContactAddressLineOne.$touch()"
                    @input="$v.newPersonEmergencyContactAddressLineOne.$touch()"

                    label="Address Line One"
                    type="text"
                    v-model="newPersonEmergencyContactAddressLineOne"
                />
            </v-flex>
            <v-flex
                md12
                sm6
                xs12
            >
                <v-text-field
                    label="Address Line Two"
                    type="text"
                    v-model="newPersonEmergencyContactAddressLineTwo"
                />
            </v-flex>
            <v-flex
                md4
                sm6
                xs12
            >
                <v-text-field
                    :error-messages="newPersonEmergencyContactTownErrors"
                    @blur="$v.newPersonEmergencyContactTown.$touch()"
                    @input="$v.newPersonEmergencyContactTown.$touch()"
                    label="Town"
                    type="text"
                    v-model="newPersonEmergencyContactTown"
                />
            </v-flex>
            <v-flex
                md4
                sm6
                xs12
            >
                <v-text-field
                    label="County"
                    type="text"
                    v-model="newPersonEmergencyContactCounty"
                />
            </v-flex>
            <v-flex
                md4
                sm6
                xs12
            >
                <v-text-field
                    :error-messages="newPersonEmergencyContactPostCodeErrors"
                    @blur="$v.newPersonEmergencyContactPostCode.$touch()"
                    @input="$v.newPersonEmergencyContactPostCode.$touch()"

                    label="Postcode"
                    type="text"
                    v-model="newPersonEmergencyContactPostCode"
                />
            </v-flex>
            <v-flex
                md4
                sm6
                xs12
            >
                <v-autocomplete
                    :error-messages="newPersonEmergencyContactCountryErrors"
                    :items="personnelCountryList"
                    @blur="$v.newPersonEmergencyContactCountry.$touch()"
                    @input="$v.newPersonEmergencyContactCountry.$touch()"
                    item-text="name"

                    item-value="personnelCountryId"
                    label="Country"
                    v-model="newPersonEmergencyContactCountry"
                />

            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
    import {mapGetters} from "vuex";
    import {email, helpers, required} from 'vuelidate/lib/validators'
    import {SET_NEW_PERSON_FORM_SECTION_STATE, UPDATE_NEW_PERSON} from "@/store/person/mutations";
    import {FETCH_PERSONNEL_COUNTRY_LIST} from "../../../store/personnel_country/actions";

    // eslint-disable-next-line
    const phone = helpers.regex('alpha', /^(\+\s?)?((^\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/);

    export default {
        name: "EmergencyContact",

        validations: {
            newPersonEmergencyContactName: {required},
            newPersonEmergencyContactRelationship: {required},

            newPersonEmergencyContactMobilePhone: {
                phone
            },
            newPersonEmergencyContactTelephone: {
                required,
                phone
            },

            newPersonEmergencyContactEmailAddress: {email},
            newPersonEmergencyContactAddressLineOne: {required},
            newPersonEmergencyContactAddressLineTwo: {},
            newPersonEmergencyContactTown: {required},
            newPersonEmergencyContactCounty: {},
            newPersonEmergencyContactPostCode: {required},
            newPersonEmergencyContactCountry: {required},
        },

        computed: {
            newPersonEmergencyContactName: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].name;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'name';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactNameErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactName.$dirty) return errors;
                !this.$v.newPersonEmergencyContactName.required && errors.push('Required.');
                return errors
            },

            newPersonEmergencyContactRelationship: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].relationship;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'relationship';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactRelationshipErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactRelationship.$dirty) return errors;
                !this.$v.newPersonEmergencyContactRelationship.required && errors.push('Required.');
                return errors
            },

            newPersonEmergencyContactMobilePhone: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].mobilePhone;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'mobilePhone';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactMobilePhoneErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactMobilePhone.$dirty) {
                    return errors;
                }
                if (!this.$v.newPersonEmergencyContactMobilePhone.phone) {
                    errors.push('Must be a valid phone number.');
                }

                return errors
            },

            newPersonEmergencyContactTelephone: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].telephone;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'telephone';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactTelephoneErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactTelephone.$dirty) {
                    return errors;
                }
                if (!this.$v.newPersonEmergencyContactTelephone.required) {
                    errors.push('Required.');
                }
                if (!this.$v.newPersonEmergencyContactTelephone.phone) {
                    errors.push('Must be a valid phone number.');
                }

                return errors
            },

            newPersonEmergencyContactEmailAddress: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].emailAddress;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'emailAddress';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactEmailAddressErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactEmailAddress.$dirty) return errors;
                !this.$v.newPersonEmergencyContactEmailAddress.email && errors.push('Must be a valid email address.');
                return errors
            },

            newPersonEmergencyContactAddressLineOne: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].addressLineOne;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'addressLineOne';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactAddressLineOneErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactAddressLineOne.$dirty) return errors;
                !this.$v.newPersonEmergencyContactAddressLineOne.required && errors.push('Required.');
                return errors
            },

            newPersonEmergencyContactAddressLineTwo: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].addressLineTwo;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'addressLineTwo';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactTown: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].town;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'town';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactTownErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactTown.$dirty) return errors;
                !this.$v.newPersonEmergencyContactTown.required && errors.push('Required.');
                return errors
            },

            newPersonEmergencyContactCounty: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].county;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'county';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactPostCode: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].postCode;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'postCode';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactPostCodeErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactPostCode.$dirty) return errors;
                !this.$v.newPersonEmergencyContactPostCode.required && errors.push('Required.');
                return errors
            },

            newPersonEmergencyContactCountry: {
                get() {
                    return this.$store.state.person.newPerson.emergencyContacts[0].personnelCountryId;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'emergencyContacts';
                    data.key = 'personnelCountryId';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonEmergencyContactCountryErrors() {
                const errors = [];
                if (!this.$v.newPersonEmergencyContactCountry.$dirty) return errors;
                !this.$v.newPersonEmergencyContactCountry.required && errors.push('Required.');
                return errors
            },

            ...mapGetters(
            [
                "personnelCountryList",
                "relationshipTypeList"
            ]
            ),
        },

        mounted() {
            this.fetchPersonnelCountryList();
        },

        methods: {
            fetchPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },

            validate() {
                this.$v.$touch();
                let formState = false;
                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'emergencyContact', state: formState});
            },
        },
    }
</script>

<style scoped>

</style>
